(function () {
  const drawer = document.querySelector('[data-fb-cart-drawer]');
  if (!drawer) return;

  const itemsNode = drawer.querySelector('[data-fb-cart-items]');
  const footerNode = drawer.querySelector('[data-fb-cart-footer]');
  const totalNode = drawer.querySelector('[data-fb-cart-total]');
  const currency = window.Shopify?.currency?.active || 'EUR';
  const locale = document.documentElement.lang || 'de-DE';

  function money(cents) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((cents || 0) / 100);
    } catch (error) {
      return `${((cents || 0) / 100).toFixed(2)} ${currency}`;
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[char]);
  }

  function renderCart(cart) {
    if (!cart || !cart.item_count) {
      itemsNode.innerHTML = '<p class="fb-cart-drawer__empty">Ihr Warenkorb ist leer.</p>';
      footerNode.hidden = true;
      return;
    }

    itemsNode.innerHTML = cart.items.map((item) => {
      const image = item.image
        ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
        : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p>${escapeHtml(item.variant_title)}</p>`
        : '';

      return `
        <article class="fb-cart-drawer__item">
          <a class="fb-cart-drawer__media" href="${item.url}">${image}</a>
          <div class="fb-cart-drawer__details">
            <a href="${item.url}">${escapeHtml(item.product_title)}</a>
            ${variant}
            <span>Anzahl: ${item.quantity}</span>
            <button type="button" data-fb-cart-remove="${item.key}">Entfernen</button>
          </div>
          <strong>${money(item.final_line_price)}</strong>
        </article>
      `;
    }).join('');

    totalNode.textContent = money(cart.total_price);
    footerNode.hidden = false;
  }

  async function getCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return response.json();
  }

  async function refreshCart() {
    renderCart(await getCart());
  }

  async function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fb-cart-drawer-open');
    await refreshCart();
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fb-cart-drawer-open');
  }

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-fb-cart-trigger]');
    if (trigger) {
      event.preventDefault();
      await openDrawer();
      return;
    }

    if (event.target.closest('[data-fb-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const removeButton = event.target.closest('[data-fb-cart-remove]');
    if (removeButton) {
      event.preventDefault();
      removeButton.disabled = true;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: removeButton.getAttribute('data-fb-cart-remove'), quantity: 0 })
      });
      await refreshCart();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.fb-product-form');
    if (!form || event.submitter?.name === 'return_to') return;

    event.preventDefault();
    const button = event.submitter;
    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Wird hinzugefügt...';
    }

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      await openDrawer();
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = button.dataset.originalText || 'In den Warenkorb legen';
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });
})();
